module.exports = __webpack_public_path__ + "img/error404.c10218f5.png";